module.exports = __webpack_public_path__ + "img/uparrow-preview.a7ddf6d6.svg";